export default __webpack_public_path__ + "static/media/ideasblock_logo.19e4ba99.svg";